export const PageHeader = ({ kicker, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4 s-rise">
    <div>
      <p className="s-mono text-xs uppercase tracking-[0.2em] text-[var(--s-accent)]">{kicker}</p>
      <h1 className="s-display mt-2 text-3xl sm:text-4xl">{title}</h1>
    </div>
    {children}
  </div>
);

const TONES = {
  ok: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  warn: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  bad: "border-red-500/40 text-red-300 bg-red-500/10",
  dim: "border-[var(--s-line)] text-[var(--s-dim)] bg-white/[0.03]",
};

export const Pill = ({ tone = "dim", children, ...rest }) => (
  <span className={`s-mono inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] uppercase tracking-wider ${TONES[tone]}`} {...rest}>
    {children}
  </span>
);

const TIER_TONE = { free: "dim", gold: "warn", platinum: "ok", diamond: "ok", founder: "warn" };
export const TierBadge = ({ tier, ...rest }) => (
  <Pill tone={TIER_TONE[(tier || "free").toLowerCase()] || "dim"} {...rest}>{tier || "free"}</Pill>
);

export const Empty = ({ children, ...rest }) => (
  <div className="rounded-xl border border-dashed border-[var(--s-line)] p-10 text-center text-sm text-[var(--s-dim)]" {...rest}>
    {children}
  </div>
);

export const Panel = ({ className = "", children, ...rest }) => (
  <div className={`rounded-xl border border-[var(--s-line)] bg-[var(--s-panel)] ${className}`} {...rest}>{children}</div>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="s-mono text-[11px] uppercase tracking-wider text-[var(--s-dim)]">{label}</span>
    {children}
  </label>
);
